export default "__VITE_ASSET__hCouvkwm__"